import { render, staticRenderFns } from "./personalevent.vue?vue&type=template&id=69df60ae&"
import script from "./personalevent.vue?vue&type=script&lang=js&"
export * from "./personalevent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports